(function () {
  "use strict";

  const initClickListener = () => {
    document.querySelectorAll(".tvs-group").forEach((tv) => {
      const group_items = tv.querySelectorAll(".group-item");
      group_items.forEach((item) => {
        const buttons = item.querySelectorAll(".product-sizes button");
        buttons.forEach((button) => {
          button.style.display = "";
          button.addEventListener("click", function () {
            group_items.forEach((x) => x.classList.add("hidden"));
            tv.querySelector(
              `.group-item[data-product-id="${this.dataset.productId}"]`
            )?.classList.remove("hidden");
          });
        });
      });
    });
  };

  const initCompareTV = () => {
    const compareTrigger = document.querySelector(
      "#q-series-qe-gtv .omni-compare-trigger-listing-container"
    );
    if (!compareTrigger) {
      console.error("compareTrigger not found");
      return;
    }

    document.querySelector("#compare-tv")?.append(compareTrigger);

    // manually set default product in comparison table
    // idk why, but this code was found in the previous test
    compareTrigger
      .querySelector(".omni-compare-trigger-listing")
      ?.addEventListener("click", () => {
        setTimeout(() => {
          document
            .querySelector(
              '.omni-compare__item--3 [data-content="android-pro"]'
            )
            ?.click();
        }, 10);
      });

    document
      .querySelectorAll(".omni-compare__item-info-cta")
      ?.forEach((item) => {
        item.addEventListener("click", () => {
          const currentSection = item.dataset.content;
          scrollToRow(currentSection);
        });
      });

    function scrollToRow(modifier) {
      const offset = document.querySelector(".header-wrap")?.offsetHeight + 46;
      window.scroll({
        top:
          document
            .querySelector(`[data-scroll=\"${modifier}\"]`)
            ?.getBoundingClientRect().top +
          window.scrollY -
          offset,
        behavior: "smooth",
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    initClickListener();
    // initCompareTV();
  }
})();
